/**
 * Контакты Dev48 в одном месте.
 *
 * Раньше телефон, почта и телеграм были продублированы по десятку компонентов,
 * и правка ника (sky_by → isky_by) превратилась в поиск по всему проекту.
 * Теперь все публичные контакты берутся отсюда.
 *
 * phone и phoneDisplay отличаются намеренно: в tel: и wa.me номер идёт без
 * пробелов и знаков, а в подписях — в читаемом виде.
 */
export const CONTACTS = {
  email: "info@dev48.org",

  phone: "+375293204096",
  phoneDisplay: "+375 29 320-40-96",

  telegramUrl: "https://t.me/isky_by",
  telegramHandle: "@isky_by",

  whatsappUrl: "https://wa.me/375293204096",
  whatsappDisplay: "+375 29 320-40-96",
} as const;
